const e = {
  borderRadius: "xl"
}, o = {
  borderRadius: "xl"
}, t = {
  segmentedControl: e,
  segmentedControlIndicator: o
};
export {
  t as segmentedControlsTheme
};
